<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 64 80"
    fill="none"
    stroke="currentColor"
    :class="className"
  >
    <path 
      d="M10 0H42L58 16V76C58 78.2 56.2 80 54 80H10C7.8 80 6 78.2 6 76V4C6 1.8 7.8 0 10 0Z" 
      stroke-width="4"
      stroke-linejoin="round"
    />
    
    <path d="M42 0V12C42 14.2 43.8 16 46 16H58" stroke-width="4" stroke-linejoin="round"/>

    <g stroke-width="3">
      <line x1="16" y1="26" x2="26" y2="26"/>
      <line x1="30" y1="26" x2="48" y2="26"/>
      
      <line x1="16" y1="32" x2="26" y2="32"/>
      <line x1="30" y1="32" x2="48" y2="32"/>
      
      <line x1="16" y1="38" x2="26" y2="38"/>
      <line x1="30" y1="38" x2="48" y2="38"/>
      
      <line x1="16" y1="44" x2="26" y2="44"/>
      <line x1="30" y1="44" x2="48" y2="44"/>
      
      <line x1="16" y1="50" x2="26" y2="50"/>
      <line x1="30" y1="50" x2="48" y2="50"/>
    </g>

    <line x1="6" y1="58" x2="58" y2="58" stroke-width="4"/>

    <text 
      x="32" 
      y="75" 
      text-anchor="middle" 
      font-family="Arial, Helvetica, sans-serif" 
      font-weight="bold" 
      font-size="18" 
      fill="currentColor" 
      stroke="none"
    >CSV</text>
  </svg>
</template>

<script>
export default {
  name: 'CsvFileIcon',
  props: {
    size: {
      type: [Number, String],
      default: 16
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>
